import { Chip, DropDown } from '@aibees/shared/components';
import { Stack, Tooltip, Typography } from '@mui/material';
import { memo, useCallback } from 'react';
import { CountryFlag } from './components/country-flag';
import { TAX_ID_OPTIONS } from './config';
import * as SX from './sx';
import type { TaxIdDropdownProps as Props } from './types';

export const TaxIdDropdown = memo(
  ({ className, disabled, value, onChange }: Props) => {
    const renderItem = useCallback((label: any, option: any) => {
      return (
        <Stack direction="row" alignItems="center" gap={1}>
          <CountryFlag
            iso2={option.value.split('_')[0]}
            country={option.country}
            size={18}
          />
          <Typography variant="body4" fontWeight={400} color="grey.600">
            {option.code}
          </Typography>
          <Chip
            label={option.country}
            variant="outlined"
            color="default"
            size="small"
          />
        </Stack>
      );
    }, []);

    const renderValue = useCallback(() => {
      const selectedOption = TAX_ID_OPTIONS.find((i) => i.value === value);
      const label = selectedOption
        ? `${selectedOption.code} - ${selectedOption.country}`
        : 'ID type';

      return (
        <Tooltip title={label} placement="top">
          <Typography variant="body4" sx={SX.label}>
            {label}
          </Typography>
        </Tooltip>
      );
    }, [value]);

    const options = TAX_ID_OPTIONS.map((i) => ({
      key: i.value,
      value: i.value,
      label: `${i.code} - ${i.country}`,
      code: i.code,
      country: i.country,
    }));

    return (
      <DropDown
        className={className}
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder="ID type"
        options={options}
        renderItem={renderItem}
        renderValue={renderValue}
        size="small"
      />
    );
  }
);

TaxIdDropdown.displayName = 'TaxIdDropdown';
